// Auto-generated — do not edit manually
// Re-generate with: bun scripts/boneyard-postprocess.ts website
import { registerBones, configureBoneyard } from 'boneyard-js/vue'

import _website_services_search from './website-services-search.bones.json'

configureBoneyard({"color":"rgba(0,0,0,0.08)","darkColor":"rgba(255,255,255,0.06)","animate":"pulse","stagger":30,"transition":200})

registerBones({
  "website-services-search": _website_services_search,
})
